import { IReferral } from '@sales-center/common'
import Box from '@mui/material/Box'
import { UpdateReferral } from '@user/components/Referrals/components/UpdateReferral/UpdateReferral'
import { entityReferral } from '@user/components/Settings/EntityFormSettings'
import { selectAllEntityFormSettings } from '@user/store/entityFormSettings'
import { useGetFieldActiveStates } from '@user/store/entityFormSettings/hooks/useGetFieldActiveStates'
import { useFormikContext } from 'formik'
import * as React from 'react'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { IAddOpportunityFormModel } from '../../typings'
import { WrapField } from './WrapField'
import { Theme } from '@mui/material/styles'

type Props = {
  disabled: boolean
  hideOptional: boolean
}

export const ReferralInformation: React.FC<Props> = (props) => {
  const { disabled, hideOptional } = props

  const { errors, setFieldValue, touched, values } =
    useFormikContext<IAddOpportunityFormModel>()

  const settings = useSelector(selectAllEntityFormSettings)
  const entitySettingsMap = useGetFieldActiveStates(settings, hideOptional)
  const [requiredReferral, showReferral] = entitySettingsMap.get(
    entityReferral,
  ) ?? [false, true]

  const onChangeReferral = useCallback(
    (referral: IReferral) => {
      setFieldValue(entityReferral, referral)
    },
    [setFieldValue],
  )

  return showReferral ? (
    <Box sx={{ marginTop: (theme: Theme) => theme.spacing(1.2) }}>
      <WrapField>
        <UpdateReferral
          billToCardWidth="342px"
          disabled={disabled}
          entityErrors={errors}
          onChange={onChangeReferral}
          padding="0"
          referral={values.referral ?? undefined}
          required={requiredReferral}
          salesTeamId={values.salesTeamId}
          title="Referral Information"
          touched={touched}
          name="referral"
        />
      </WrapField>
    </Box>
  ) : null
}
ReferralInformation.displayName = 'ReferralInformation'
